// extracted by mini-css-extract-plugin
export default {"menuContainer":"MenuItems_menuContainer__ZeDt0","menuItem":"MenuItems_menuItem__1U8FF","redDot":"MenuItems_redDot__U8GZ9","icon":"MenuItems_icon__DzSrR"};